var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-activity"},[_c('Icons',{attrs:{"icon":"stopwatch"}}),_vm._v(" "+_vm._s(_vm.timeOut / 1000 - _vm.timer)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }